/**
 * bugReports.api.ts
 * API клиент для работы с отчётами об ошибках.
 */

import apiClient from './client';

export interface BugReportPayload {
  description: string;
  pageUrl: string;
  route: string;
  userId?: string;
  userName?: string;
  userRole?: string;
  userEmail?: string;
  consoleLogs?: any[];
  extraContext?: Record<string, any>;
  userAgent?: string;
  screen?: string;
}

export interface BugReport {
  id: string;
  description: string;
  pageUrl: string;
  route: string;
  userId?: string;
  userName?: string;
  userRole?: string;
  userEmail?: string;
  consoleLogs?: any[];
  extraContext?: Record<string, any>;
  userAgent?: string;
  screen?: string;
  status: 'new' | 'in_progress' | 'fixed' | 'closed';
  resolutionNote?: string;
  createdAt: string;
  updatedAt: string;
}

export const BugReportsAPI = {
  async sendReport(data: BugReportPayload): Promise<BugReport> {
    const res = await apiClient.post<{ result: BugReport }>('/v3/bug-reports', data);
    return (res.data as any)?.result || res.data;
  },

  async getReports(params?: { limit?: number; status?: string }): Promise<BugReport[]> {
    const res = await apiClient.get<{ result: BugReport[] }>('/v3/admin/bug-reports', { params });
    return (res.data as any)?.result || res.data || [];
  },

  async updateStatus(id: string, status: string, resolutionNote?: string): Promise<boolean> {
    const res = await apiClient.patch(`/v3/admin/bug-reports/${id}`, { status, resolutionNote });
    return (res.data as any)?.success ?? true;
  },
};

export default BugReportsAPI;
